import React, {Component, PropTypes} from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import truncate from 'html-truncate';
import Truncate from 'react-truncate-dom';
import classnames from 'classnames';
import striptags from 'striptags';

import { Table, Alert, Spin, message, Pagination, Icon, Tooltip } from 'antd';

import { updateQuery } from 'modules/router/actions';
import { fetchFeed } from '../actions';
import { actions } from 'modules/modal';

import { setCollection } from 'modules/collection/actions';
const me = JSON.parse(localStorage.me);

const container = connect(
  createSelector(
    (state) => ({
      dataIsRead: _.get(state, 'modal.dataIsRead'),
    })
    ,
    (state) => {
      return {
        dataIsRead: state.dataIsRead,
      }
    },
  ),
  () => ({})
);

class FeedTable extends Component {

  static propTypes = {
    // mediaType: PropTypes.String, //媒体类型
    model: PropTypes.object, //数据
    query: PropTypes.object, //查询条件
    dispatch: PropTypes.func, //触发器
    originalDispatch: PropTypes.func, //原始的触发器
    clipping: PropTypes.array, //剪報列表
    canClipping: PropTypes.bool, //是否有剪報權限
  };

  static defaultProps = {
    model: {
      data: [],
      count: 0,
    },
  };

  state = {
    sort: {},
    current: 1
  }

  componentDidMount() {
    const {model, dispatch, query} = this.props;
    dispatch(fetchFeed({
      query: {
        ...query,
        ...this.state.sort,
        limit: 15,
      }
    }));
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.query, nextProps.query)) {
      const { dispatch, query } = nextProps;
      this.setState({
        current: 1
      })
      dispatch(fetchFeed({
        query: {
          ...query,
          ...this.state.sort,
          limit: 15,
        }
      }));
    }
  }

  onPageChange = (current) => {
    const { dispatch, query } = this.props;
    this.setState({
      current: current
    })
    dispatch(fetchFeed({
      query: {
        ...query,
        ...this.state.sort,
        limit: 15,
        offset: (current - 1) * 15,
      }
    }));
  };

  handleClick = (data) => {
    const {originalDispatch} = this.props;
    originalDispatch(actions.toggleArticleModal(data));
  };

  handleAddToClip = (globalId) => {
    const {originalDispatch} = this.props;
    originalDispatch(setClipping({
      type: 'ADD',
      globalId: [globalId]
    }))
    .then(() => {
      message.success(t('commonClippingSuccess'))
    });
  };

  replaceNbsp = (str) => {
    if (!_.isEmpty(str)){
      return str.replace(/&nbsp;/gi,"");
    } else {
      return str
    }
  }

  handleOnekeyAddToClip = () => {
    const {originalDispatch, model} = this.props;
    const globalIds = _.map(model.data, 'globalId')
    originalDispatch(setClipping({
      type: 'ADD',
      globalId: globalIds
    }))
    .then(() => {
      message.success(t('commonClippingSuccess'))
    });
  };

  constColumns = () => {
    const { originalDispatch, query, mediaTypes, clipping, canClipping, dataIsRead } = this.props;
    const lang = _.get(me, 'lang');
    const { mediaType } = query;
    let width = {
      medaiType: 80,
      comments: 80,
      likes: 80,
      shares: 80,
      hotvalue: 75,
      views: 80,
      words: 60,
      sentiment: 60,
      controller: 75,
      date: 140,
    }
    if (lang === 'en') {
      width = {
        medaiType: 110,
        comments: 140,
        likes: 80,
        shares: 100,
        hotvalue: 125,
        views: 90,
        words: 100,
        sentiment: 90,
        controller: 95,
        date: 175,
      }
    }
    let columns = null;
    switch(mediaType) {
      case 'news':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle}
                onClick={() => this.handleClick(data)}>
                <Truncate
                  line={2}
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), width: 80, dataIndex: 'from', key: 'from', render: (from,data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>{from}</a>},
          {title: t('commonIn'), width: 80, dataIndex: 'in', key: 'in',
            render: (ins, data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [data.from],in: [ins]}))}}>{ins}</a>},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width: width.words, sorter: true},
          {title: t('commonSentiment'), dataIndex: 'sentiment', key: 'sentiment', width: width.sentiment, render: (sentiment) => {
            let value = '--'
            if (sentiment !== undefined && sentiment !== null) {
              value = sentiment.toFixed(2)
            }
            return (
              <span>{value}</span>
            )
          }},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'weibo':
        columns = [
          {title: t('commonContent'), width: 100, dataIndex: 'content', key: 'content', render: (content, data) => {
            let repContent = '';
            if (!_.isEmpty(content)) {
              repContent = content.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repContent} onClick={() => this.handleClick(data)}>
                <Truncate
                  line={2}
                  html={content}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), width: 75, dataIndex: 'from', key: 'from', render: (from, data) => {
            return (
              <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
                <Truncate
                  html={from}
                />
              </a>
            )
          }},
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width: width.comments, sorter: true},
          {title: t('commonLikes'), dataIndex: 'likes', key: 'likes', width: width.likes, sorter: true},
          {title: t('commonShares'), dataIndex: 'shares', key: 'shares', width: width.shares, sorter: true},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width: width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'facebook':
        columns = [
          {title: t('commonContent'), width: 100, dataIndex: 'content', key: 'content', render: (content, data) => {
            let repContent = '';
            if (!_.isEmpty(content)) {
              repContent = content.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repContent} onClick={() => this.handleClick(data)}>
                <Truncate
                  line={2}
                  html={content}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), width: 80, dataIndex: 'from', key: 'from', render: (from, data) => {
            return (
              <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
                <Truncate
                  html={from}
                />
              </a>
            )
          }},
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width: width.comments, sorter: true},
          {title: t('commonLikes'), dataIndex: 'likes', key: 'likes', width: width.likes, sorter: true},
          {title: t('commonShares'), dataIndex: 'shares', key: 'shares', width: width.shares, sorter: true},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width: width.words, sorter: true},
          {title: t('commonHotvalue'), dataIndex: 'hotvalue', key: 'hotvalue', width: width.hotvalue, sorter: true, render: (hotvalue) => {
            let value = '--'
            if (hotvalue !== undefined && hotvalue !== null) {
              value = hotvalue.toFixed(2)
            }
            return (
              <span>{value}</span>
            )
          }},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: width.date, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'twitter':
        columns = [
          {title: t('commonContent'), dataIndex: 'content', key: 'content', render: (content, data) => {
            let repContent = '';
            if (!_.isEmpty(content)) {
              repContent = content.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repContent} onClick={() => this.handleClick(data)}>
                <Truncate
                  line={2}
                  html={content}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), width: 100, dataIndex: 'from', key: 'from', render: (from, data) => {
            return (
              <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
                <Truncate
                  html={from}
                />
              </a>
            )
          }},

          {title: t('commonLikes'), dataIndex: 'likes', key: 'likes', width: width.likes, sorter: true},
          {title: t('commonShares'), dataIndex: 'shares', key: 'shares', width: width.shares, sorter: true},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width: width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'wechat':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>{from}</a>, width: 120},
          {title: t('commonHits'), dataIndex: 'hits', key: 'hits', width:width.views, sorter: true},
          {title: t('commonLikes'), dataIndex: 'likes', key: 'likes', width:width.likes, sorter: true},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'forum':
      case 'forumComment':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', width: 100, key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  line={2}
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => {
            return (
              <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
                <Truncate
                  html={from}
                />
              </a>
            )
          }, width:75},
          {title: '', dataIndex: 'position', key: 'position', width: 60, render: (position) => {
            let value  = 1;
            if (position !== null) {
              value = position
            }
            return (
              <span>#{value}</span>
            )
          }},
          {title: t('commonHits'), dataIndex: 'hits', key: 'hits', width:width.views, sorter: true,
            render: (hits) => {
              let value = '--'
              if (hits !== undefined && hits !== null) {
                value = hits
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width:width.comments, sorter: true,
            render: (comments) => {
              let value = '--'
              if (comments !== undefined && comments !== null) {
                value = comments
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonHotvalue'), dataIndex: 'hotvalue', key: 'hotvalue', width: width.hotvalue, sorter: true, render: (hotvalue) => {
            let value = '--'
            if (hotvalue !== undefined && hotvalue !== null) {
              value = hotvalue.toFixed(2)
            }
            return (
              <span>{value}</span>
            )
          }},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: width.date, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'pixnet':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
            <Truncate html={from}/></a>, width:100},
          {title: t('commonHits'), dataIndex: 'hits', key: 'hits', width:width.views, sorter: true,
            render: (hits) => {
              let value = '--'
              if (hits !== undefined && hits !== null) {
                value = hits
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width:width.comments, sorter: true,
            render: (comments) => {
              let value = '--'
              if (comments !== undefined && comments !== null) {
                value = comments
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'youtube':
        columns = [
          {title: t('commonTitle'), width: 140, dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a title={from} onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>
            <Truncate html={from}/></a>, width:75},
          {title: t('commonHits'), dataIndex: 'hits', key: 'hits', width:width.views, sorter: true,
            render: (hits) => {
              let value = '--'
              if (hits !== undefined && hits !== null) {
                value = hits
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonLikes'), dataIndex: 'likes', key: 'likes', width: width.likes, sorter: true},
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width:width.comments, sorter: true,
            render: (comments) => {
              let value = '--'
              if (comments !== undefined && comments !== null) {
                value = comments
              }
              return (
                <span>{value}</span>
              )
            }
          },
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'page':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>{from}</a>, width:100},
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width:width.comments, sorter: true},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      case 'goods':
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            if (!_.isEmpty(title)) {
              repTitle = title.replace(/<[^>]+>/g,"")
            }
            return (
              <a
                className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                title={repTitle} onClick={() => this.handleClick(data)}>
                <Truncate
                  html={title}
                />
              </a>
            )
          }},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>{from}</a>, width:100},
          {title: t('commonComments'), dataIndex: 'comments', key: 'comments', width:width.comments, sorter: true},
          {title: t('commonAverage'), dataIndex: 'averageScore', key: 'averageScore', width:80},
          {title: t('commonPrice'), dataIndex: 'price', key: 'price', width:50},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
      default:
        columns = [
          {title: t('commonTitle'), dataIndex: 'title', key: 'title', render: (title, data) => {
            let repTitle = '';
            let repContent = '';
            if (_.isEmpty(title)){
              repContent = data.content.replace(/<[^>]+>/g,"")
              return (
                <a
                  className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})}
                  title={repContent} onClick={() => this.handleClick(data)}>
                  <Truncate
                    line={2}
                    html={data.content}
                  />
                </a>
              )
            }else {
              repTitle = title.replace(/<[^>]+>/g,"")
              return (
                <a className={classnames({'read-table' : _.includes(dataIsRead, data.globalId)})} title={repTitle} onClick={() => this.handleClick(data)}>
                  <Truncate
                    html={title}
                  />
                </a>
              )
            }
          }},
          {title: t('commonMedia'), dataIndex: 'mediaType', key: 'mediaType', width:width.medaiType, render: (mediaType) => <span>{mediaTypes[mediaType].name}</span>},
          {title: t('commonFrom'), dataIndex: 'from', key: 'from', render: (from, data) => <a onClick={() => {originalDispatch(updateQuery({mediaType: data.mediaType, from: [from]}))}}>{from}</a>, width:100},
          {title: t('commonWords'), dataIndex: 'words', key: 'words', width:width.words, sorter: true},
          {title: t('commonDate'), dataIndex: 'date', key: 'date', width: 140, render: (date) => moment(date).format('YYYY-MM-DD HH:mm'), sorter: true},
          {title: <div className='text-center'><a onClick={this.handleOnekeyAddToClip}>{t('quickCliped')}</a></div>, width: width.controller, dataIndex: 'key', key: 'key', render: (key,data) => {
            const id = data.globalId;
            const disabled = _.includes(clipping, id)
            return (
              <div className='text-center'>
              {disabled &&
                <span className="text-muted">{t('commonCliped')}</span>
              ||
                <a onClick={() => this.handleAddToClip(id)}>{t('commonClipping')}</a>
              }
              </div>
            )
          }}
        ];
        break;
    }

    if(!canClipping) {
      columns.pop();
    }
    return columns
  }

  constDataSource = () => {
    const { model } = this.props;
    const dataSource = _.map(model.data, (d, i) => {
      const obj = {
        ...d,
        key: d.globalId + i,
      }
      return obj;
    })
    return dataSource;
  }

  tableChange = (pagination, filters, sorter) => {
    const {dispatch, query} = this.props;
    if (_.isEmpty(sorter)) {
      dispatch(fetchFeed({
        query: {
          ...query,
          limit: 15,
        }
      }))
    }
    if (sorter.order == "descend") {
      this.setState({
        sort: {
          sort: sorter.columnKey,
          order: 'desc',
        }
      })
      dispatch(fetchFeed({
        query: {
          ...query,
          sort: sorter.columnKey,
          order: 'desc',
          limit: 15,
        }
      }));
    } else if (sorter.order == "ascend") {
      this.setState({
        sort: {
          sort: sorter.columnKey,
          order: 'asc',
        }
      })
      dispatch(fetchFeed({
        query: {
          ...query,
          sort: sorter.columnKey,
          order: 'asc',
          limit: 15,
        }
      }));
    }
  }

  showTotal = (total) => {
    return t('commonShowTotal', {total: total});
  }

  render() {
    const { model, query } = this.props;
    const columns = this.constColumns();
    const dataSource = this.constDataSource();
    return (
      <div className="feed-list margin-bottom-md">
        {!model.isLoading && model.count === 0 &&
          <Alert
            message={t('commonNoData')}
            description={t('commonAlertDescription')}
            type="info"
            showIcon={true}
          />
        ||
        <div>
          <Table
            columns={columns}
            size="small"
            dataSource={dataSource}
            pagination={false}
            onChange={this.tableChange}
            loading={model.isLoading}
          />
          <Pagination showQuickJumper className="pull-right padding-md" pageSize={15} current={this.state.current} total={model.count} showTotal={this.showTotal} onChange={this.onPageChange}/>
        </div>

        }
    </div>
  );
  }
}

export default container(FeedTable)



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/components/FeedTable.js
 **/